import { getProfile } from '../../../data/repositories/userRepository.js';

export const fetchProfile = () => getProfile();
